<div [ngClass]="isHorizontal ? 'divider-horizontal' : 'divider-vertical'">
</div>
